import { ReactNode } from "react";
import { Card } from "@/components/ui/card";

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#004161] via-[#b1c3cf] to-[#f1eceb] relative overflow-hidden py-8 px-4">
      {/* Abstract background shapes */}
      <div className="absolute inset-0 w-full h-full">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#0f8f8c]/20 blur-[100px] animate-blob"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-[#cfb9a2]/20 blur-[100px] animate-blob animation-delay-2000"></div>
        <div className="absolute top-[40%] left-[30%] w-[50%] h-[50%] rounded-full bg-[#b1c3cf]/20 blur-[100px] animate-blob animation-delay-4000"></div>
      </div>

      <div className="w-full px-0 relative z-10">
        <Card className="w-full backdrop-blur-sm bg-[#ffffff]/95 shadow-sm border-0 rounded-3xl overflow-hidden">
          {children}
        </Card>
      </div>
    </div>
  );
} 